import './js/autorization';
import './js/searchFilms';
import './js/modalFilm';
import './js/filter';
import './js/microphone';
import './js/scrollUp';
import './js/modal_developer';
